import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const logoutUser = async () => {
      try {
        const valueToKeep = localStorage.getItem("hasSeenWelcomeModal");

        localStorage.clear();
        sessionStorage.clear();

        if (valueToKeep !== null) {
          localStorage.setItem("hasSeenWelcomeModal", valueToKeep);
        }
        
        navigate("/");

      } catch (error) {
        console.error("Erro ao deslogar:", error?.message);
        navigate("/");
      }
    };

    setTimeout(() => {
      logoutUser();
    }, 1000);

  }, [navigate]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f5f5",
        overflow: "hidden",
        animation: "fadeOut 2s ease-in-out forwards",
      }}
    >
      <h1
        style={{
          fontSize: "2.5rem",
          color: "#333",
          animation: "zoomOut 1.5s ease-in-out forwards",
        }}
      >
        Saindo...
      </h1>
      <style>
        {`
        @keyframes fadeOut {
          0% { background-color: #f5f5f5; }
          100% { background-color: #ffffff; }
        }
        @keyframes zoomOut {
          0% { transform: scale(1); opacity: 1; }
          100% { transform: scale(0.5); opacity: 0; }
        }
      `}
      </style>
    </div>
  );
};

export default Logout;
